const userManage = {
  state: {
    beginUpdate: new Date(),
    detail: {}
  },
  mutations: {
    set_userManage_update (state, data) {
      state.beginUpdate = data
    },
    set_userManage_detail (state, data) {
      state.detail = data
    }
  },
  getters: {

  },
  actions: {

  }
}

export default userManage
